import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';

@Injectable({
  providedIn: 'root'
})
export class TranslateConfigService {
  language;
  constructor(
    private translate: TranslateService,
    private storage: Storage
  ) { }

  getLang() {
    return this.language;
  }
  async initLang() {
    if (this.language != null)
      return this.language;
    let storage_lang = await this.storage.get('lang');
    console.log("storage_lang", storage_lang);
    if (storage_lang != null) {
      this.language = storage_lang;
      this.translate.setDefaultLang(this.language);
      return this.language;
    }
    else return this.getDefaultLanguage();
  }
  getDefaultLanguage() {
    let language = this.translate.getBrowserLang();
    this.translate.setDefaultLang(language);
    console.log("setDefaultLang", language)
    this.language = language;
    return language;
  }

  setLanguage(setLang) {
    console.log("setLanguage", setLang)
    this.language = setLang;
    this.storage.set('lang', setLang);
    this.translate.use(setLang);
    this.translate.get('setLanguage APP_TITLE').subscribe((res: string) => {
      console.log("APP_TITLE", res);
      //=> 'hello world'
    });
  }

}